import React, { useState, useRef, useEffect } from 'react'
import {
  TooltipContainer,
  TooltipContent,
  Column,
  Label,
  Value,
  Header,
} from './style'
import { Freight } from '../../contexts/RouterContext'

interface FreightItem {
  id: number
  company: {
    companyName: string
  }
  address: {
    street: string
    number: string
    cep: string
    complement?: string
    neighborhood: {
      name: string
      city: {
        name: string
        state: {
          uf: string
          name: string
        }
      }
    }
  }
  routeId?: number | null
  observation?: string
  type?: string
  deadLine?: string
  orderNumber?: string
  load: {
    height?: number
    width?: number
    length?: number
    cubage?: number
    weight?: number
    detail?: string
  }
}

interface RouterTooltipProps {
  freight: Freight
  children: React.ReactNode
}

const RouterTooltip: React.FC<RouterTooltipProps> = ({ freight, children }) => {
  const [visible, setVisible] = useState(false)
  const [position, setPosition] = useState({ x: 0, y: 0 })
  const tooltipRef = useRef<HTMLDivElement>(null)

  const dataFormatter = (isoDateString: string | undefined): string => {
    if (!isoDateString) {
      return 'N/A'
    }
    const dateUtc = new Date(isoDateString)
    if (isNaN(dateUtc.getTime())) {
      return 'N/A'
    }
    const year = dateUtc.getUTCFullYear()
    const month = dateUtc.getUTCMonth() + 1
    const day = dateUtc.getUTCDate()
    const formattedMonth = month < 10 ? `0${month}` : month
    const formattedDay = day < 10 ? `0${day}` : day
    return `${formattedDay}/${formattedMonth}/${year}`
  }

  const handleMouseEnter = (e: React.MouseEvent) => {
    setPosition({ x: e.clientX, y: e.clientY })
    setVisible(true)
  }

  const handleMouseLeave = () => {
    setVisible(false)
  }


  useEffect(() => {
    if (visible && tooltipRef.current) {
      const windowHeight = window.innerHeight
      const tooltipHeight = tooltipRef.current.offsetHeight
      const newY = position.y + 20

      if (newY + tooltipHeight > windowHeight) {
        const adjustedY = position.y - tooltipHeight - 20
        setPosition((prev) => ({ ...prev, y: adjustedY < 0 ? 10 : adjustedY }))
      }
    }
  }, [visible, position.y])

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {children}
      {visible && (
        <TooltipContainer
          ref={tooltipRef}
          style={{ left: position.x + 20, top: position.y }}
        >
          <Header>Frete - {freight.id}</Header>
          <TooltipContent>
            
            <Column>
              <Label>Cliente/fornecedor:</Label>
              <Value>{freight.Company.companyName}</Value>
              <Label>Tipo:</Label>
              <Value>{freight.type || 'N/A'}</Value>
              <Label>Data limite:</Label>
              <Value>{dataFormatter(freight.deadLine)}</Value>
              <Label>Número da venda:</Label>
              <Value>{freight.orderNumber || 'N/A'}</Value>
            </Column>
            
            <Column>
              <Label>CEP:</Label>
              <Value>
                {freight?.Address?.cep
                  ? `${String(freight.Address.cep).slice(0, 5)}-${String(
                      freight.Address.cep,
                    ).slice(5)}`
                  : 'N/A'}
              </Value>
              <Label>Endereço:</Label>
              <Value>{`${freight?.Address?.street || 'N/A'}, ${freight?.Address?.number || 'N/A'}`}</Value>
              <Label>Bairro:</Label>
              <Value>{freight?.Address?.Neighborhood?.name || 'N/A'}</Value>
              <Label>Cidade/Estado:</Label>
              <Value>{`${freight?.Address?.Neighborhood?.City?.name || 'N/A'}/${freight?.Address?.Neighborhood?.City?.State?.uf || 'N/A'}`}</Value>
              <Label>Complemento:</Label>
              <Value>{freight?.Address?.complement || 'N/A'}</Value>
            </Column>
            
            <Column>
              <Label>Altura:</Label>
              <Value>{freight.Load?.height || 0}</Value>
              <Label>Largura:</Label>
              <Value>{freight.Load?.width || 0}</Value>
              <Label>Comprimento:</Label>
              <Value>{freight.Load?.length || 0}</Value>
              <Label>Cubagem:</Label>
              <Value>{freight.Load?.cubage || 0}</Value>
              <Label>Peso:</Label>
              <Value>{freight.Load?.weight || 0}</Value>
              <Label>Detalhamento:</Label>
              <Value>{freight.Load?.detail || 'N/A'}</Value>
              <Label>Observações:</Label>
              <Value>{freight.observation || 'N/A'}</Value>
            </Column>
          </TooltipContent>
        </TooltipContainer>
      )}
    </div>
  )
}

export default RouterTooltip
